import { useQuery } from '@apollo/client';
import getCartData from '../queries/cart.graphql';

export const useCart = (cartId: string) => useQuery(getCartData, { variables: { cartId }, skip: !cartId, ssr: false });
